// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__HLsL1","cell":"ColumnAccessor_cell__2znps","firstCellAccent":"ColumnAccessor_firstCellAccent__fqYhi"};